import { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import app from '../../services/firebase';
import { AccountBox, AccountBoxRounded, AccountBoxTwoTone, AccountCircle, AccountCircleOutlined, HelpCenter, Login, LoginOutlined, Person, Person2Rounded, Person3Outlined, PersonOutlineRounded, PersonPinCircle, PersonSharp } from '@mui/icons-material';
import AccountProfile from './AccountProfile';

const AccountStatusIcon = ({ _status = null, photoUrl = null, onStatusChange = null}) => {
  const auth = getAuth(app);
  const navigate = useNavigate();
  const [user, setUser] = useState(null)
  const [status, setStatus] = useState('signed-off');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        setUser(authUser);
        setStatus(authUser.photoURL ? 'signed-on-with-photo' : 'signed-on-without-photo');
      } else {
        setUser(null);
        setStatus('signed-off');
      }
    });

    return () => unsubscribe();
  }, []);

  const handleStatusChange = async () => {
    if (status === 'signed-off') {
      navigate('/auth/signon');
    } else {
      if (window.confirm("Are you sure you want to sign out?")) {
        try {
          await signOut(auth)
          navigate('./');
        } catch (error) {
          console.log('Sign out error:', error.message)
        }
      }
    
    }
  };

  const handleClick = () => {
    if (onStatusChange) {
      onStatusChange();
    }
  };

  switch (status) {
    case 'signed-off':
      return (
        <IconButton onClick={handleStatusChange} aria-label="Sign In">
          <LoginOutlined color="action"/>
        </IconButton>
      );
    case 'signed-on-with-photo':
      return (
        <IconButton onClick={handleStatusChange} aria-label="Account">
          <Avatar alt="User Profile" src={photoUrl} />
        </IconButton>
      );
    case 'signed-on-without-photo':
      return (
        <IconButton onClick={handleStatusChange} aria-label="Account">
          <PersonOutlineRounded color="secondary" />
        </IconButton>
      );
    default:
      return (
        <IconButton onClick={handleStatusChange} aria-label="Account">
          <HelpCenter />
        </IconButton>
      );
  }
};

export default AccountStatusIcon;